export default {
	isIe: () => {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) return true;
        else return false;
    },

	isEdge: () => {
		if (/Edge\/\d./i.test(navigator.userAgent)) {
			return true;
		}

		return false;
	},

	isSafari: () => {
		if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) return true;
		else return false;
	},

	isFirefox: () => {
		if (typeof InstallTrigger !== 'undefined') return true;
		else return false;
	},

	isOpera: () => {
		if ((!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) return true;
		else return false;
	},

	isChrome: () => {
		var isChromium = window.chrome;
		var winNav = window.navigator;
		var vendorName = winNav.vendor;
		var isOpera = typeof window.opr !== "undefined";
		var isIEedge = winNav.userAgent.indexOf("Edge") > -1;

		if (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false ) return true;
		else return false;
	},

	isIOS: () => {
		if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)) return true;
		else return false;
	},

	isIOSSafari: () => {
		if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform) && !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/)) return true;
		else return false;
	},

	isIOSChrome: () => {
		if (!!navigator.userAgent.match('CriOS')) return true;
		else return false;
	},

	isIOSFirefox: () => {
		if (!!navigator.userAgent.match('FxiOS')) return true;
		else return false;
	},

	isAndroid: () => {
		if (navigator.userAgent.toLowerCase().indexOf("android") > -1) return true;
		else return false;
	},

	iOSVersion: () => {
		const match = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
		const version = [
			parseInt(match[1], 10),
			parseInt(match[2], 10),
			parseInt(match[3] || 0, 10)
		];
	  
		return parseFloat(version.join('.'));
	  }
};
